import { ServerUsedServiceType, ServerSubscriptionTypeVariationEnum } from '@expane/data'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { InformationPopup } from 'widgets/InformationPopup'
import { getUsedServiceByServiceId, getTotalUsedServicesForSubscription } from '@expane/logic/cards'

export const SubscriptionServicesInfoIcon: FC<{
  usedServices: ServerUsedServiceType[]
  subscriptionServices: Array<{
    serviceId: number
    serviceQuantity: number
    service: { name: string; id: number }
  }>
  subscriptionTypeVariation: ServerSubscriptionTypeVariationEnum | null
  sharedQuantity: number | null
}> = ({ usedServices, subscriptionServices, subscriptionTypeVariation, sharedQuantity }) => {
  const { t } = useTranslation()

  const isSharedSubscription =
    subscriptionTypeVariation === ServerSubscriptionTypeVariationEnum.Shared

  return (
    <InformationPopup
      size="1.2rem"
      openByClick
      containerClassName={'text-gray-600 dark:text-gray-400'}
    >
      <p className="text-main-color text-sm mb-2 font-medium">{`${t('services')}:`}</p>

      {isSharedSubscription ? (
        <>
          {subscriptionServices.map(subscriptionService => {
            const usedService = getUsedServiceByServiceId(
              usedServices,
              subscriptionService.serviceId,
            )
            const usedCount = usedService?.used || 0

            return (
              <div
                className="flex justify-between text-main-color text-sm pl-0.5"
                key={subscriptionService.serviceId}
              >
                <span className="truncate mr-2">{subscriptionService.service.name}</span>
                <span>{usedCount}</span>
              </div>
            )
          })}

          {/* Строка с общим количеством */}
          <div className="flex justify-between text-main-color text-sm pl-0.5 mt-2 pt-2 border-t border-gray-200">
            <span className="truncate mr-2 font-medium">{t('total')}</span>
            <span className="font-medium">
              {getTotalUsedServicesForSubscription(usedServices)}/{sharedQuantity}
            </span>
          </div>
        </>
      ) : (
        // Для PerService абонемента показываем по услугам
        subscriptionServices.map(subscriptionService => {
          return (
            <div
              className="flex justify-between text-main-color text-sm pl-0.5"
              key={subscriptionService.serviceId}
            >
              <span className="truncate mr-2">{subscriptionService.service.name}</span>
              <span>
                {getUsedServiceByServiceId(usedServices, subscriptionService.serviceId)?.used}/
                {getUsedServiceByServiceId(usedServices, subscriptionService.serviceId)?.quantity}
              </span>
            </div>
          )
        })
      )}
    </InformationPopup>
  )
}
